"use strict";

var _context, _context2;
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/for-each");
var _Object$keys = require("@babel/runtime-corejs3/core-js/object/keys");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
var _format = require("./format");
_forEachInstanceProperty(_context = _Object$keys(_format)).call(_context, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _format[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _format[key];
    }
  });
});
var _parseInterfaces = require("./parse-interfaces");
_forEachInstanceProperty(_context2 = _Object$keys(_parseInterfaces)).call(_context2, function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _parseInterfaces[key]) return;
  _Object$defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _parseInterfaces[key];
    }
  });
});